module.exports = __webpack_public_path__ + "img/shadow.5c0f04ca.png";